import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../Link';
import s from './PostFooter.css';

function renderLink(path, name) {
  if (path) {
    return (
      <Link to={`${path}/`}>
        {name}
      </Link>
    );
  }
  return (
    <div />
  );
}

class PostFooter extends React.Component {

  static propTypes = {
    previousPath: PropTypes.string,
    nextPath: PropTypes.string,
  };

  render() {
    const previousString = '< previous';
    const nextString = 'next >';
    return (
      <div className={s.linkContainer}>
        {renderLink(this.props.previousPath, previousString)}
        {renderLink(this.props.nextPath, nextString)}
      </div>
    );
  }

}

export default withStyles(s)(PostFooter);



// WEBPACK FOOTER //
// src/components/PostFooter/PostFooter.js